export default "A retrospective on the ups and downs of owning my 2016 Corvette for the past year!";